import { Popover, DialogContent, Button, Grid2, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'core/contexts/localization';

import { useStyles } from './styles';
import { useState } from 'react';

const FutureEventsModal = ({ show, onClose, anchorEl, save, onSave, onDelete }) => {
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const THIS_OPTION = 'this';
    const ALL_OPTION = 'all';
    const FOLLOWING_OPTION = 'following';
    const updateOptions = [THIS_OPTION, ALL_OPTION, FOLLOWING_OPTION];
    const [updateOption, setUpdateOption] = useState(THIS_OPTION);

    const handleOption = (event) => {
        const value = event?.target?.value;
        setUpdateOption(value);
    };

    const getValueName = (value) => {
        switch (value) {
            case THIS_OPTION:
                return translate('form.future_events.this_event');
            case ALL_OPTION:
                return translate('form.future_events.all_events');
            case FOLLOWING_OPTION:
                return translate('form.future_events.this_and_following');
            default:
                return translate('form.future_events.this_event');
        }
    };

    const handleSubmit = () => {
        let all = false;
        let thisAndFollowing = false;

        if (updateOption === ALL_OPTION) {
            all = true;
        } else if (updateOption === FOLLOWING_OPTION) {
            thisAndFollowing = true;
        }

        if (save) {
            onSave(all, thisAndFollowing);
        } else {
            onDelete(all, thisAndFollowing);
        }
    };

    return (
        <Popover
            onClose={onClose}
            open={show}
            anchorReference="anchorEl"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            disableRestoreFocus
        >
            <DialogContent className={classes.content}>
                <Typography fontSize="20px" fontWeight="bold" textAlign="start" sx={{ marginBottom: '1em', marginTop: '1em' }}>
                    {save ? translate('form.future_events.save') : translate('form.future_events.delete')}
                </Typography>

                <FormControl fullWidth>
                    <RadioGroup value={updateOption} onChange={handleOption}>
                        {updateOptions.map((updateValue) => (
                            <FormControlLabel
                                key={updateValue}
                                value={updateValue}
                                control={
                                    <Radio
                                        sx={{
                                            color: '#131313',
                                            '&.Mui-checked': {
                                                color: '#131313',
                                            },
                                        }}
                                    />
                                }
                                label={getValueName(updateValue)}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>

                <Grid2 container justifyContent={{ xs: 'center', md: 'flex-end' }} alignItems="center" my="1em" gap="8px">
                    <Grid2 width={{ xs: '100%', md: 'fit-content' }}>
                        <Button
                            onClick={() => {
                                onClose();
                            }}
                            sx={{ color: '#131313 !important', width: { xs: '100%', md: 'fit-content' }, borderRadius: '8px', fontSize: '.75em', fontWeight: 'bold', border: 'solid 1px #13131340' }}
                            variant="outlined"
                        >
                            {translate('profile.btn_cancel')}
                        </Button>
                    </Grid2>
                    <Grid2 width={{ xs: '100%', md: 'fit-content' }}>
                        <Button type="submit" variant="contained" sx={{ color: 'white !important', width: { xs: '100%', md: 'fit-content' }, borderRadius: '8px', fontSize: '.75em', fontWeight: 'bold', backgroundColor: save ? '#137DC5' : '#C51313' }} onClick={handleSubmit}>
                            {save ? translate('form.future_events.save') : translate('form.future_events.delete')}
                        </Button>
                    </Grid2>
                </Grid2>
            </DialogContent>
        </Popover>
    );
};

export default FutureEventsModal;
